import React, { PropsWithChildren } from "react";

type AccountLogoutType = {
    showAccountLogout: boolean;
};

export const AccountLogoutContext = React.createContext<AccountLogoutType>({
    showAccountLogout: false,
});

export const AccountLogoutActionsContext = React.createContext({
    toggleLogout: () => {
        // empty function
    },
    hideAccountLogout: () => {
        // empty function
    },
});

export const useAccountLogoutContext = () => React.useContext(AccountLogoutContext);

export const useAccountLogoutActionsContext = () => React.useContext(AccountLogoutActionsContext);

export const AccountLogoutContextProvider = (props: PropsWithChildren<{}>) => {
    const [showAccountLogout, setShowAccountLogout] = React.useState<boolean>(false);

    const toggleLogout = React.useCallback(() => {
        setShowAccountLogout((prevState) => !prevState);
    }, []);

    const hideAccountLogout = React.useCallback(() => setShowAccountLogout(false), []);

    const accountLogoutContextValue = React.useMemo(
        () => ({ showAccountLogout }),
        [showAccountLogout]
    );

    const accountLogoutActionsContextValue = React.useMemo(
        () => ({ toggleLogout, hideAccountLogout }),
        [toggleLogout, hideAccountLogout]
    );

    return (
        <AccountLogoutContext.Provider value={accountLogoutContextValue}>
            <AccountLogoutActionsContext.Provider value={accountLogoutActionsContextValue}>
                {props.children}
            </AccountLogoutActionsContext.Provider>
        </AccountLogoutContext.Provider>
    );
};
